import { css } from "@emotion/react";
import styled from "@emotion/styled";
import {
  EmailInput as SignUpNewsletterEmailInput,
  StyledSignupButton as SignUpNewsletterSignUpButton,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/email-form/styles";
import { SubmitButton as SignUpButtonSubmitButton } from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/sign-up-button/styles";
import {
  Container as SocialButtonContainer,
  IconContainer as SocialButtonIconContainer,
} from "scmp-sdk/components/newsletter/newsletter-widget/sign-up-newsletter/social-buttons/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { fontRoboto, theme } from "shared/lib/styles";

export const AgreementCheckboxContainer = styled.div`
  display: flex;
  align-items: center;

  cursor: pointer;
`;

export const AgreementDescription = styled.div`
  margin-inline-start: 8px;

  color: #333333;
  font-size: 11px;
  font-family: ${fontRoboto};
  line-height: 13px;
  text-align: start;
`;

type AgreementContainerProps = {
  theme?: ThemeType;
};
export const AgreementContainer = styled.div<AgreementContainerProps>`
  display: flex;

  margin-block-start: 8px;
`;

type ActionContainerProps = {
  $isShowCombinedSocialAndEmail: boolean;
};

export const ActionContainer = styled.div<ActionContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: start;

  inline-size: 100%;
  block-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    justify-content: space-between;
    align-items: end;

    inline-size: 214px;

    ${props =>
      props.$isShowCombinedSocialAndEmail &&
      css`
        inline-size: 451px;
      `}
  }
`;

export const TermAndConditionLink = styled.a`
  margin-block: 0;
`;

type TermAndConditionContainerProps = {
  $textAlignEnd?: boolean;
};
export const TermAndConditionContainer = styled.p<TermAndConditionContainerProps>`
  max-inline-size: 100%;
  margin-block-start: 8px;

  color: #666666;
  font-size: 10px;
  font-family: ${fontRoboto};
  line-height: 11px;
  text-align: start;
  word-break: break-word;

  ${theme.breakpoints.up("tablet")} {
    text-align: ${props => (props.$textAlignEnd ? "end" : "start")};
  }

  ${TermAndConditionLink} {
    color: #666666;
    text-decoration: underline;
  }
`;

type ContainerProps = {
  theme?: ThemeType;
};
export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-flow: column;
  gap: 2px;
  place-items: center center;

  max-inline-size: 500px;
  margin: auto;
  padding: 0;

  color: #ffffff;
  text-align: center;

  ${SignUpButtonSubmitButton} {
    display: flex;
    justify-content: center;
    align-items: center;

    block-size: 36px;
    min-inline-size: 173px;
    padding-inline: 16px;
    ${theme.breakpoints.up("tablet")} {
      min-inline-size: 205px;
    }
  }

  ${SignUpNewsletterSignUpButton} {
    min-inline-size: 74px;
    padding-inline: 10px;

    font-family: ${fontRoboto};
  }

  ${SocialButtonContainer} {
    justify-content: center;

    ${SocialButtonIconContainer} {
      background-color: #ffffff;
    }
  }

  ${SignUpNewsletterEmailInput} {
    ${theme.breakpoints.up("tablet")} {
      inline-size: 218px;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    max-inline-size: initial;
    margin: initial;

    text-align: center;
  }
`;

export const Main = styled.div`
  display: flex;
  flex-flow: column;

  inline-size: 100%;
  ${theme.breakpoints.up("tablet")} {
    flex-flow: row;
  }
`;

export const Bottom = styled.div`
  ${theme.breakpoints.up("tablet")} {
    align-self: flex-end;
  }
`;

export const TitleAndDescriptionContainer = styled.div`
  inline-size: 100%;

  text-align: center;
  ${theme.breakpoints.up("tablet")} {
    margin-inline-end: 21px;

    text-align: start;
  }
`;

export const SummaryContainer = styled.div`
  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 0;
  }
`;

export const NewsletterCTAContainer = styled.div`
  block-size: 100%;

  ${theme.breakpoints.up("tablet")} {
    display: flex;
  }
`;

export const ActionAndTermsContainer = styled.div`
  inline-size: 100%;
`;

export const EmptyDiv = styled.div`
  display: none;
`;

export const FadeContainer = styled.div`
  ${theme.breakpoints.up("tablet")} {
    display: flex;
    justify-content: unset;

    inline-size: 100%;
  }
`;

export const ContentContainer = styled.div`
  display: none;
  ${theme.breakpoints.up("tablet")} {
    display: flex;

    inline-size: 100%;
  }
`;
export const MobileContentContainer = styled.div`
  display: block;

  text-align: start;
  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const CTALink = styled.a`
  display: none;

  color: #666666;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRoboto};
  text-align: center;
  text-align: end;
  text-transform: uppercase;
  text-decoration: underline;

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const Divider = styled.div`
  inline-size: 100%;
  block-size: 1px;
  margin-block: 12px;

  background-color: rgba(0, 0, 0, 0.2);
`;

export const MobileOnlyNewsletterCTA = styled.div`
  display: block;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const TabletUpNewsletterCTA = styled.div`
  display: none;

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;

export const TabletUpAgreementContainer = styled.div`
  display: none;

  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;
